import { c as _c } from "react/compiler-runtime";
/**
 * Component to show when a drop is not found
 */
export default function DropNotFound() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-h-6 tw-w-6 tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-relative tw-flex-shrink-0 tw-rounded-md z-10"><div className="tw-h-full tw-w-full tw-bg-iron-800 tw-rounded-md" /></div><p className="tw-mb-0 tw-text-sm tw-text-iron-200 tw-font-semibold">Drop not found</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}